export const customCheckboxStyles = {
  root: {
    width: '24px',
    height: '24px',
    checkedBackground: 'rgba(36, 49, 74, 1)',
    borderColor: 'rgba(36, 49, 74, 1)',
    checkedHoverBackground: 'rgb(80, 90, 110)',
    checkedBorderColor: 'rgba(36, 49, 74, 1)',
    checkedHoverBorderColor: 'rgb(80, 90, 110)'
  }
}